import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import { RowLeft } from '../Styles';
import OptionButton from '../components/Button/OptionButton';
import LeftToRight from '../components/Animation/LeftToRight';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import RobotReply from '../components/Reply/RobotReply';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import { getFoodifoxDataLazy } from '../../../../../lib/axios/FoodifoxDataAPI';
import RobotLoading from '../components/Loading/RobotLoading';
import Q1 from '../Q1';
import Q12 from '../Q12';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import UserReply from '../components/Reply/UserReply';

/**
 * 感谢您的使用，请取走您的食物并关闭柜门
 */
const Q21: FC<Props> = ({
  addElement,
  setTargetPage,
  cabId,
  deviceCode,
  h5Platform,
  sessionId,
  enterPhoneNumber,
}) => {
  // 检查当前柜子有没有订单
  const [checkCabHasOrder] = getFoodifoxDataLazy<{ id: string; question: string; answer: { [key: string]: string } }>('/fox3PDAi/start');

  const option1 = { zhValue: '是的，需要', enValue: 'Yes' };
  const option2 = { zhValue: '结束对话', enValue: 'Quit' };

  /**
   * 检测是否还有订单
   */
  const checkHasOrder = () => {
    const loadingFlowId = uuid();
    addElement(
      <RowLeft>
        <RobotLoading flowId={loadingFlowId} />
      </RowLeft>
    );

    checkCabHasOrder({
      param: {
        useCabId: cabId,
      },
      onError() {
        addElement(
          <Q12 />
        );
      },
      onCompleted({ id }) {
        setTimeout(() => {
          // 隐藏loading
          TempFieldUtils.aiFlowIds.push(loadingFlowId);
        }, 2000);
        setTimeout(() => {
          // 隐藏loading
          if (id === '1') {
            addElement(
              <Q1
                addElement={addElement}
                cabId={cabId}
                deviceCode={deviceCode}
                enterPhoneNumber={enterPhoneNumber}
                setTargetPage={() => {
                  setTargetPage('support');
                }}
                sessionId={sessionId}
              />,
            );
          }
          if (id === '12') {
            addElement(
              <Q12 />
            );
          }
        }, 2200);
      }
    });
  };

  useEffect(() => {
    // 流程ID
    const flowId = uuid();
    const langZh = '感谢您的使用，请取走您的食物并关闭柜门。祝您用餐愉快！请问是否还需要其 他帮助？';
    const langEn = 'Thank you for using Foodifox. Please take your delivery and close the door. Can I help with anything else?';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ alignItems: 'center' }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.55, getWindowWidth() * 0.58) }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q21 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <OptionButton
              langZh={option1.zhValue}
              langEn={option1.enValue}
              flowId={flowId}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q21 - user: ' + option1.enValue, sessionId);
                addElement(
                  <UserReply
                    langZh={option1.zhValue}
                    langEn={option1.enValue}
                  />
                );

                // 检测是否还有订单
                checkHasOrder();
              }}
            />
          </RowLeft>
          <RowLeft>
            <OptionButton
              langZh={option2.zhValue}
              langEn={option2.enValue}
              flowId={flowId}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q21 - user: ' + option2.enValue, sessionId);
                setTargetPage('support');
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  cabId: number;
  deviceCode: string;
  h5Platform: number;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q21;
